import { LanguageString } from '@myriadgenetics/mgh-types';

export const languageOptions = [
  {
    label: 'languageOptions.english',
    value: LanguageString.English,
  },
  {
    label: 'languageOptions.spanish',
    value: LanguageString.Spanish,
  },
];
